import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {FloatingButtonAction} from '@share/component/floating-button/floating-button';

/**
 * Service de gestion des fournisseurs
 *
 * @author Yannick Gauthier
 * @date 15/07/2025
 */
@Injectable()
export class FournisseursTabsService {
    /** Liste des actions disponibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>([]);
    
    /** Sujet pour les actions de l'onglet actif */
    activeTabActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>([]);
    
    /** Code de l'onglet actif */
    private activeTabCode: BehaviorSubject<string> = new BehaviorSubject<string>('GENERALITES');

    /**
     * Définit les actions pour les boutons flottants
     * @param actions Liste des actions à afficher
     */
    setActions(actions: Array<FloatingButtonAction>): void {
        this.listeActions.next(actions);
    }

    /**
     * Efface les actions des boutons flottants
     */
    clearActions(): void {
        this.listeActions.next([]);
    }

    /**
     * Définit le code de l'onglet actif
     * @param code Code de l'onglet
     */
    setActiveTabCode(code: string): void {
        this.activeTabCode.next(code);
    }

    /**
     * Récupère le code de l'onglet actif
     * @returns Code de l'onglet actif
     */
    getActiveTabCode(): string {
        return this.activeTabCode.value;
    }

    /**
     * Récupère l'observable du code de l'onglet actif
     * @returns Observable du code de l'onglet actif
     */
    getActiveTabCode$(): Observable<string> {
        return this.activeTabCode.asObservable();
    }

    /**
     * Définit les actions pour l'onglet actif
     * @param actions Liste des actions
     */
    setActiveTabActions(actions: Array<FloatingButtonAction>): void {
        this.activeTabActions.next(actions);
    }

    /**
     * Récupère l'observable des actions de l'onglet actif
     * @returns Observable des actions de l'onglet actif
     */
    getActiveTabActions$(): Observable<Array<FloatingButtonAction>> {
        return this.activeTabActions.asObservable();
    }
}
